import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, copy, align = "left" }) => (
  <div className={align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}>
    <Reveal>
      <p className="text-xs font-semibold tracking-[0.3em] uppercase text-gold mb-5" data-testid="section-eyebrow">
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink text-balance">
        {title}
      </h2>
    </Reveal>
    {copy && (
      <Reveal delay={0.16}>
        <p className="mt-6 text-base md:text-lg text-[#5C5C5C] leading-relaxed">{copy}</p>
      </Reveal>
    )}
  </div>
);
